import React from 'react';
import { Card } from '@parsina/framework';

import { C, CT } from '../../constants/theme';
import { useTranslation } from '../../i18n/I18nProvider.jsx';
import KitRecordListSheet from '../common/RecordListSheet.jsx';

// «مشاهدهٔ همه» — the full list a rail section is showing three of.
//
// The rail is 300 pixels wide beside a note being written, so every block in it
// is CLIPPED: three medications, three problems, the latest vitals. That is the
// right default and it is only tolerable because the rest is one click away —
// otherwise the student has to leave the visit to read their own record, and
// leaving the visit is exactly what a workspace exists to avoid.
//
// The SHELL is the shared `components/common/RecordListSheet` (a drawer on a
// desktop, a bottom sheet on a phone); this is the visit's ROW renderer over it,
// because the rail's rows are history entries and derived views rather than the
// record screen's sections. Read-only, always: the note being written is on the
// other side of the screen, and an editable rail is a way to change a record
// while believing you are consulting it.

export default function RailListSheet({ open, onClose, title, items = [], renderItem, empty }) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <KitRecordListSheet open={open} onClose={onClose} title={title}>
      {!items.length && (
        <p style={{ fontSize: 13, color: CT.mute }}>{empty || t('visit.rail.emptyList')}</p>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {items.map((item, i) => (
          <Card key={item.id || `row-${i}`} style={{ padding: 10 }}>
            {renderItem
              ? renderItem(item)
              : (
                <p style={{ margin: 0, fontSize: 13, lineHeight: 1.95, color: C.textPrimary, whiteSpace: 'pre-wrap' }}>
                  {item.body || item.title || ''}
                </p>
              )}
          </Card>
        ))}
      </div>
    </KitRecordListSheet>
  );
}
